import React, {Component} from "react";
import Head from "../../components/Head";
import Subscribe from "../../components/Subscribe";
import {withTranslate} from "react-redux-multilingual"
import globalMiddleware from "../../hocs/globalMiddleware";
import BlogPosts from "../../components/blog/BlogPosts";
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";


class Blog extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }
    render() {

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];

        return (
            <div className="About">
                <Head title={this.props.translate("blog")} history={history}/>

                <section className="ftco-section">
                    <div className="container">
                        <BlogPosts/>
                    </div>
                </section>
                <Subscribe/>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Blog)));